import { render, staticRenderFns } from "./DetailAnalysis.vue?vue&type=template&id=417bd39c&scoped=true&"
import script from "./DetailAnalysis.vue?vue&type=script&lang=js&"
export * from "./DetailAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417bd39c",
  null
  
)

export default component.exports